import "./FiltersButton.scss";

import FiltersButton from "./FiltersButton";

export default FiltersButton;
